export default "/images/60d55cef4e3cca21b43c370332b58256.png";